import { styled, keyframes } from '@mui/material/styles';
import { Button, Card, Box, Typography } from '@mui/material';

const blink = keyframes`
  from {
    opacity: 0.5;
  }
  to {
    opacity: 1;
  }
`;

export const StyledFab = styled(Button)({
  position: 'fixed',
  bottom: '20px',
  borderRadius: '8px',
  width: '97px'
});

export const DetailedCard = styled(Card, {
  shouldForwardProp: prop => prop !== 'loading'
})(({ theme, loading }) => ({
  textAlign: 'left',
  width: '100%',
  boxShadow: 'none',
  marginBottom: theme.spacing(2),
  [theme.breakpoints.up('sm')]: {
    width: '47%',
    marginRight: theme.spacing(0.5),
    marginLeft: theme.spacing(0.5)
  },
  [theme.breakpoints.up('md')]: {
    width: '33%',
    marginRight: theme.spacing(0.5),
    marginLeft: theme.spacing(0.5)
  },
  padding: theme.spacing(2, 2, 0, 2),
  display: 'inline-block',
  verticalAlign: 'top',
  position: 'relative',
  ...(loading && {
    filter: 'blur(5px)',
    animation: `${blink} 1s alternate infinite linear`
  })
}));

export const SingleItemRow = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  minHeight: '50px',
  marginBottom: theme.spacing(2)
}));

export const StyledDeviceIconWrapper = styled('span')(({ theme }) => ({
  '& svg, & img': {
    fontSize: 32,
    width: '20px',
    verticalAlign: 'middle',
    marginRight: theme.spacing(1)
  }
}));

export const LabelText = styled(Typography)({
  fontWeight: '500',
  color: 'grey'
});
